// extracted by mini-css-extract-plugin
module.exports = {"root":"app_root__2GZmG","main":"app_main__28wsq","sidebar":"app_sidebar__1KVTx"};